module.exports = __webpack_public_path__ + "static/media/icons.e07ab0a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icons.svg?pv0exl
// module id = 2536
// module chunks = 7